export default `
mutation deleteBoundedContext($boundedContextId: ID!) {
  deleteBoundedContext(boundedContextId: $boundedContextId)
}

`
